const DAY_IN_MS = 1000 * 60 * 60 * 24;
const HOUR_IN_MS = DAY_IN_MS / 24;
const SEC_IN_MS = HOUR_IN_MS / 60;
const MS_IN_SEC = 1000;

export const getHumanTimeFormatFromMilliseconds = (
  ms: number,
): { days: number; hours: number; minutes: number; seconds: number } => {
  const days = Math.floor(ms / DAY_IN_MS);
  const hours = Math.floor((ms % DAY_IN_MS) / HOUR_IN_MS);
  const minutes = Math.floor((ms % HOUR_IN_MS) / SEC_IN_MS);
  const seconds = Math.floor((ms % SEC_IN_MS) / MS_IN_SEC);

  return {
    days: days > 0 ? days : 0,
    hours: hours > 0 ? hours : 0,
    minutes: minutes > 0 ? minutes : 0,
    seconds: seconds > 0 ? seconds : 0,
  };
};

export function formatTime(time: number) {
  return time <= 9 ? `0${time}` : time;
}
